// components/FloatingWidget/FloatingWidgetContext.jsx
'use client'

// Lets a page (e.g. a property detail page) feed data to the root-level widget:
//   vars    → template variables for prefill text, e.g. { ref, propertyTitle }
//   targets → per-channel overrides, e.g. { whatsapp: agent.whatsapp }
//             (only used by channels with "Use page target" switched on)
//   hide    → hide the widget on this page regardless of route rules

import { createContext, useContext, useEffect, useState } from 'react'

const FloaterCtx = createContext({ page: {}, setPage: () => {} })

export function FloatingWidgetProvider({ children }) {
  const [page, setPage] = useState({})
  return <FloaterCtx.Provider value={{ page, setPage }}>{children}</FloaterCtx.Provider>
}

export const useFloaterPage = () => useContext(FloaterCtx).page

export function FloaterPageContext({ vars, targets, hide = false }) {
  const { setPage } = useContext(FloaterCtx)
  const key = JSON.stringify({ vars, targets, hide })

  useEffect(() => {
    setPage({ vars, targets, hide })
    return () => setPage({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, setPage])

  return null
}
